import { BaseSlider } from "../traits/base-slider";

/**
 * Pages slider component
 *
 */
export default class PagesSlider extends BaseSlider {
    private articles: HTMLElement[] = [];

    constructor(sliderWrapper: HTMLElement) {
        const slider: HTMLElement = sliderWrapper.querySelector(".pages-slider"),
            articles: HTMLElement[] = Array.from(sliderWrapper.getElementsByTagName("article")),
            totalItems: number = articles.length,
            buttonNext: HTMLElement = sliderWrapper.querySelector(".pages-slider-button-next"),
            buttonPrev: HTMLElement = sliderWrapper.querySelector(".pages-slider-button-prev");

        super(slider, totalItems, buttonNext, buttonPrev);

        this.articles = articles;
        this.init();
    }

    private init() {
        if (this.getTotalItems() <= 1) {
            this.getButtonNext().style.display = "none";
            this.getButtonPrev().style.display = "none";
        }

        this.setupAriaVisibility();
    }

    private setupAriaVisibility(): void {
        const slider = this.getSlider();

        if (!slider || this.articles.length === 0) {
            return;
        }

        this.articles.forEach((article) => article.setAttribute("aria-hidden", "true"));

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    const article = entry.target as HTMLElement;
                    const isVisible = entry.isIntersecting && entry.intersectionRatio >= 0.5;

                    if (isVisible) {
                        article.removeAttribute("aria-hidden");
                    } else {
                        article.setAttribute("aria-hidden", "true");
                    }
                });
            },
            {
                root: slider,
                threshold: [0, 0.5, 1],
            },
        );

        this.articles.forEach((article) => observer.observe(article));
    }
}
